import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta as any).env.VITE_SUPABASE_URL;
const supabaseAnonKey = (import.meta as any).env.VITE_SUPABASE_ANON_KEY;

// Log environment status for debugging (only in development)
if (import.meta.env.DEV) {
  console.log('Supabase URL configured:', !!supabaseUrl);
  console.log('Supabase Anon Key configured:', !!supabaseAnonKey);
}

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables:', {
    hasUrl: !!supabaseUrl,
    hasKey: !!supabaseAnonKey,
    mode: import.meta.env.MODE,
  });
  throw new Error('Missing Supabase environment variables. Please check your environment configuration.');
}

// Use 'any' type for flexibility with dynamically added tables
// TODO: Regenerate types when database schema is stable
export const supabase: SupabaseClient<any> = createClient<any>(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce', // More secure auth flow
    // Bypass navigator.locks to prevent AbortError on Safari and when
    // tabs/strict-mode double-mounts race for the browser lock.
    // The Supabase client still serialises refreshes via its own internal queue.
    lock: async (_name: string, _acquireTimeout: number, fn: () => Promise<any>) => {
      return await fn();
    },
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
  global: {
    headers: {
      'x-client-info': 'blazepos-web',
    },
  },
});

// Helper to get the current user's profile
export async function getCurrentProfile() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const { data: profile } = await supabase
    .from('profiles')
    .select('*, organization:organizations(*)')
    .eq('id', user.id)
    .single();

  return profile;
}

// Helper to get user's accessible locations
export async function getUserLocations() {
  const { data: locations } = await supabase
    .from('locations')
    .select('*')
    .eq('is_active', true)
    .order('name');

  return locations || [];
}

